// AUTO-GENERATED by shared/generators/config_enums_generator.py — do not edit.
// SalesUnmatchedDeliveryReason — source: shared/config/sales_unmatched_delivery_reasons.config.json

export const SALES_UNMATCHED_DELIVERY_REASON_VALUES = ["sample_shipment", "warranty_replacement", "internal_use", "customer_pickup_no_so", "other"] as const;
export type SalesUnmatchedDeliveryReason = (typeof SALES_UNMATCHED_DELIVERY_REASON_VALUES)[number];

